// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".menu-header{margin-top:15px;box-shadow:200px 2px 4px -1px rgba(0,0,0,.2),0 4px 5px 0 rgba(0,0,0,.14),0 1px 10px 0 rgba(0,0,0,.12);background-color:#fff;background-color:var(--v-surface-base,#fff);text-align:center}.menu-header img{margin:0 auto;max-width:80%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
